import React from 'react';
import { useIntl } from '@leagueplatform/locales';
import { usePageViewAnalytics } from '@leagueplatform/analytics';
import { useDocumentTitle } from '@leagueplatform/web-common';
import { Masonry } from '@leagueplatform/masonry';
import { MASONRY } from 'common/constants';
import { usePatientPortalMasonryProps } from 'hooks/queries/use-patient-portal-masonry-props.hook';
import { MasonryPageLayout } from 'components/masonry-page-layout/masonry-page-layout.component';
import { PATIENT_PORTAL_SYSTEM_IDS } from 'types/patient-portal-system.types';
import { usePatientPortalContext } from 'contexts/patient-portal-provider.context';

export const HomePage = () => {
  usePageViewAnalytics({ screen_name: 'Home' });
  const { formatMessage } = useIntl();
  const { systemId } = usePatientPortalContext();
  const isAmplar = systemId === PATIENT_PORTAL_SYSTEM_IDS.AMPLAR;
  useDocumentTitle(formatMessage({ id: 'STR_HOME' }));
  const masonryProps = usePatientPortalMasonryProps({
    nodeId: MASONRY.ROOT_NODE_ID_HOME_PAGE,
  });

  return (
    <MasonryPageLayout
      css={{
        ...(isAmplar && { paddingTop: '$three' }),
        '@mobile': {
          padding: '$two $one',
        },
      }}
    >
      <Masonry {...masonryProps} />
    </MasonryPageLayout>
  );
};
